import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Navigate, RouteProps, useLocation } from 'react-router-dom'
import { useIdleTimer } from 'react-idle-timer'

import BaseRoute from './BaseRoute'

// utils
import { isLoggedIn } from '../utils/auth'
import { PAGE, REFRESH_PAGE_INTERVAL } from '../utils/enums'

type Props = RouteProps & {
	layout?: any
	page?: PAGE
}

const onIdle = () => {
	document.location.reload()
}

const AuthRoute: FC<Props> = (props) => {
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	const [t] = useTranslation()
	const { pathname, search } = useLocation()

	// NOTE: prevent to have cached app version
	useIdleTimer({
		element: document,
		timeout: REFRESH_PAGE_INTERVAL,
		onIdle,
		debounce: 250
	})

	if (!isLoggedIn()) {
		return <Navigate to={t('paths:prihlasenie') as string} state={{ redirectFrom: pathname + search }} />
	}

	return <BaseRoute {...(props as any)} />
}

export default AuthRoute
